module.exports = {
	"permanent": "永久",
	"buttons": {
		"cancel": "取消",
		"close": "關閉",
		"copy": "複製",
		"copyFile": "複製檔案",
		"copyToClipboard": "複製到剪貼簿",
		"create": "建立",
		"delete": "刪除",
		"download": "下載",
		"info": "資訊",
		"more": "更多",
		"move": "移動",
		"moveFile": "移動檔案",
		"new": "新",
		"next": "下一個",
		"ok": "確認",
		"replace": "更換",
		"previous": "上一個",
		"rename": "重新命名",
		"reportIssue": "報告問題",
		"save": "儲存",
		"search": "搜尋",
		"select": "選擇",
		"share": "分享",
		"publish": "發佈",
		"selectMultiple": "選擇多個",
		"schedule": "計畫",
		"switchView": "切換顯示方式",
		"toggleSidebar": "切換側邊欄",
		"update": "更新",
		"upload": "上傳",
		"permalink": "獲取永久連結"
	},
	"success": {
		"linkCopied": "連結已複製！"
	},
	"errors": {
		"forbidden": "你被禁止存取。",
		"internal": "伺服器出了點問題。",
		"notFound": "找不到檔案。"
	},
	"files": {
		"folders": "資料夾",
		"files": "檔案",
		"body": "Body",
		"clear": "清空",
		"closePreview": "關閉預覽",
		"home": "主頁",
		"lastModified": "最後修改",
		"loading": "讀取中...",
		"lonely": "這裡沒有任何檔案...",
		"metadata": "詮釋資料",
		"multipleSelectionEnabled": "多選模式已開啟",
		"name": "名稱",
		"size": "大小",
		"sortByName": "按名稱排序",
		"sortBySize": "按大小排序",
		"sortByLastModified": "按最後修改時間排序"
	},
	"help": {
		"click": "選擇檔案或目錄",
		"ctrl": {
			"click": "選擇多個檔案或目錄",
			"f": "打開搜尋列",
			"s": "儲存檔案或下載目前資料夾"
		},
		"del": "刪除所選的檔案/資料夾",
		"doubleClick": "打開檔案/資料夾",
		"esc": "清除已選項或關閉提示資訊",
		"f1": "顯示該幫助資訊",
		"f2": "重新命名檔案/資料夾",
		"help": "幫助"
	},
	"login": {
		"password": "密碼",
		"submit": "登入",
		"username": "帳號",
		"wrongCredentials": "帳號或密碼錯誤"
	},
	"prompts": {
		"copy": "複製",
		"copyMessage": "請選擇欲複製至的目錄：",
		"currentlyNavigating": "目前目錄：",
		"deleteMessageMultiple": "你確定要刪除這 {count} 個檔案嗎?",
		"deleteMessageSingle": "你確定要刪除這個檔案/資料夾嗎?",
		"deleteTitle": "刪除檔案",
		"displayName": "名稱：",
		"download": "下載檔案",
		"downloadMessage": "請選擇要下載的壓縮格式。",
		"error": "發出了一點錯誤...",
		"fileInfo": "檔案資訊",
		"filesSelected": "已選擇 {count} 個檔案。",
		"lastModified": "最後修改",
		"move": "移動",
		"moveMessage": "請選擇欲移動至的目錄：",
		"newDir": "建立目錄",
		"newDirMessage": "請輸入新目錄的名稱。",
		"newFile": "建立檔案",
		"newFileMessage": "請輸入新檔案的名稱。",
		"numberDirs": "目錄數",
		"numberFiles": "檔案數",
		"replace": "替換",
		"replaceMessage": "您嘗試上傳的檔案中有一個與現有檔案的名稱存在衝突。是否取代現有的同名檔案？",
		"rename": "重新命名",
		"renameMessage": "請輸入新名稱，舊名稱為：",
		"show": "顯示",
		"size": "大小",
		"schedule": "計畫",
		"scheduleMessage": "請選擇發佈這篇貼文的日期。",
		"newArchetype": "建立一個基於原型的新貼文。您的檔案將會建立在內容資料夾中。"
	},
	"settings": {
		"admin": "管理員",
		"administrator": "管理員",
		"allowCommands": "執行命令",
		"allowEdit": "編輯、重命名或刪除檔案/目錄",
		"allowNew": "創建新檔案和目錄",
		"allowPublish": "發佈新的貼文與頁面",
		"avoidChanges": "(留空以避免更改)",
		"changePassword": "更改密碼",
		"commands": "命令",
		"commandsHelp": "在這裡，您可以設定在指定事件下執行的命令，一行一條。若事件與檔案相關，如“在保存檔案前”，則檔案的路徑會被賦值給環境變數 \"FILE\"。",
		"commandsUpdated": "命令已更新！",
		"customStylesheet": "自定義樣式表",
		"examples": "範例",
		"globalSettings": "全域設定",
		"language": "語言",
		"lockPassword": "禁止使用者修改密碼",
		"newPassword": "您的新密碼",
		"newPasswordConfirm": "重輸一遍新密碼",
		"newUser": "建立使用者",
		"password": "密碼",
		"passwordUpdated": "密碼已更新！",
		"permissions": "權限",
		"permissionsHelp": "您可以將該使用者設置為管理員，也可以單獨選擇各項權限。如果選擇了“管理員”，則其他的選項會被自動勾上，同時該使用者可以管理其他使用者。",
		"profileSettings": "個人設定",
		"ruleExample1": "封鎖使用者存取所有資料夾下任何以 . 開頭的檔案(隱藏文件, 例如: .git, .gitignore)。",
		"ruleExample2": "封鎖使用者存取其目錄範圍的根目錄下名為 Caddyfile 的檔案。",
		"rules": "規則",
		"rulesHelp1": "您可以為該使用者製定一組黑名單或白名單式的規則，被屏蔽的檔案將不會顯示在清單中，使用者也無權限存取,支持相對於目錄範圍的路徑。",
		"rulesHelp2": "每行一條規則，且必須以關鍵字 {0} 或 {1} 開頭。如要使用規則運算式，請在加上 {2} 之後再附上運算式或路徑。",
		"scope": "目錄範圍",
		"settingsUpdated": "設定已更新！",
		"user": "使用者",
		"userCommands": "使用者命令",
		"userCommandsHelp": "指定該使用者可以執行的命令，用空格分隔。例如：",
		"userCreated": "使用者已建立！",
		"userDeleted": "使用者已刪除！",
		"userManagement": "使用者管理",
		"username": "使用者名稱",
		"users": "使用者",
		"userUpdated": "使用者已更新！"
	},
	"sidebar": {
		"help": "幫助",
		"logout": "登出",
		"myFiles": "我的檔案",
		"newFile": "建立檔案",
		"newFolder": "建立資料夾",
		"settings": "設定",
		"siteSettings": "網站設定",
		"hugoNew": "Hugo New",
		"preview": "預覽"
	},
	"search": {
		"images": "影像",
		"music": "音樂",
		"pdf": "PDF",
		"pressToExecute": "按確定鍵執行。",
		"pressToSearch": "按確定鍵搜尋。",
		"search": "搜尋...",
		"searchOrCommand": "搜尋或者執行命令...",
		"searchOrSupportedCommand": "搜尋或使用您可以使用的命令(一次只能執行一個命令)：",
		"type": "輸入並按確定鍵進行搜尋。",
		"types": "類型",
		"video": "影片",
		"writeToSearch": "請輸入要搜尋的內容"
	},
	"languages": {
		"en": "English",
		"fr": "Français",
		"pt": "Português",
		"ja": "日本語",
		"zhCN": "中文 (简体)",
		"zhTW": "中文 (繁體)",
		"es": "Español",
		"de": "Deutsch"
	},
	"time": {
		"unit": "時間單位",
		"seconds": "秒",
		"minutes": "分鐘",
		"hours": "小時",
		"days": "天"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-tw.yaml
// module id = 287
// module chunks = 0